import React from 'react';
import { Typography } from '@mui/material';

export default function ExternalLogins() {
    return (
        <Typography variant="h5">
            Inicio de Sesión Externo
        </Typography>
    );
}
